module.exports = __webpack_public_path__ + "img/2.0dfb8387.png";